import { Component } from '@angular/core';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { BreadcrumbService, IBreadcrumb } from './breadcrumb.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-breadcrumb',
    template: require('./breadcrumb.component.html'),
    styles: [require('./breadcrumb.component.scss')]
})

export class AppBreadcrumbComponent {

    constructor(
        public service: BreadcrumbService,
        private sampleTrackingStorage: SampleTrackingStorage,
        private router: Router
    ) { }

    public onBreadCrumbClick(breadcrumb: IBreadcrumb) {
        if (breadcrumb.data) {
            this.sampleTrackingStorage.sampleSearchData = new Observable(ob => ob.next(breadcrumb.data));
        }
        if (breadcrumb.clearCachedData) {
            this.sampleTrackingStorage.clearGridData();
        }
        this.router.navigate(breadcrumb.url);
    }
}